import Chart from "react-apexcharts";

const StatusDistribution = ({ analytics = {} }) => {
  const series = [
    Number(analytics?.open || 150),
    Number(analytics?.answered || 20),
    Number(analytics?.closed || 55),
    Number(analytics?.cancelled || 70),
    Number(analytics?.reopened || 56),
  ];

  const options = {
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
    },
    labels: ["Open", "Answered", "Closed", "Cancelled", "Re-opened"],
    colors: [
      "#2563eb", // Open
      "#7c3aed", // Answered
      "#16a34a", // Closed
      "#94a3b8", // Cancelled
      "#ea580c", // Re-opened
    ],
    stroke: {
      width: 0,
    },
    legend: {
      show: true,
    },
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <div className="p-3">
      <Chart options={options} series={series} type="donut" height={180} />
    </div>
  );
};

export default StatusDistribution;
